import { useQuery } from '@tanstack/react-query';

import http from '@/tscapi/service/httpservice';
import { Cookie } from '@/tscapi/utils/cookie';

export const useCategories = () => {
    const cookie: Cookie = new Cookie();
    return useQuery({
        queryKey: ['categories', cookie.Language],
        queryFn: fetchCategories,
        useErrorBoundary: true,
        retry: false,
        refetchOnWindowFocus: false,
    });

    async function fetchCategories() {
        const base = '/api/v2/';
        const lang = cookie.Language.substring(0, 2) || 'en';
        try {
            const response = await http.get(`${base}${lang}/shopbycategory`);
            return response.data.MerchandisingZones ?? [];
        } catch (error) {
            console.log('Error getting Categories');
            throw new Error('Error getting Categories');
        }
    }
};
